import { Skeleton } from '@/components/custom';

interface TProps {
    count?: number;
}

const DataTableMobileSkeleton = ({ count = 5 }: TProps) => {
    return (
        <div className="space-y-4">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="flex items-center justify-between p-4 border rounded-lg bg-card text-card-foreground shadow-xs">
                    {/* Left: Icon + Name/Role */}
                    <div className="flex items-center space-x-4">
                        <Skeleton className="h-10 w-10 rounded-full" />
                        <div className="space-y-2">
                            <Skeleton className="h-4 w-32" />
                            <Skeleton className="h-3 w-24" />
                        </div>
                    </div>
                    {/* Right: Amount + Status */}
                    <div className="flex flex-col items-end space-y-2">
                        <Skeleton className="h-4 w-20" />
                        <div className="flex items-center space-x-1">
                            <Skeleton className="h-2 w-2 rounded-full" />
                            <Skeleton className="h-3 w-16" />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default DataTableMobileSkeleton;
